import React from 'react';

import { humanizeLabel } from '../../services/formatting';
import { BadgeTone, statusLabel, statusTone } from './statusTones';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** A status, whose tone comes from statusTones. Children override its label. */
  status?: string | null;
  /** Set a tone directly. Prefer `status`, so colours stay consistent. */
  tone?: BadgeTone | 'outline';
}

/**
 * A status pill, or with tone="outline" a label that is not a status (Certified,
 * Scope 3). Status badges carry a dot so state is not told by colour alone.
 */
const Badge: React.FC<BadgeProps> = ({ status, tone, className, children, ...rest }) => {
  const resolved = tone ?? statusTone(status);
  return (
    <span
      {...rest}
      className={[
        'ui-badge',
        `ui-badge--${resolved}`,
        resolved === 'outline' ? '' : 'ui-badge--dot',
        className || '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {typeof children === 'string' ? humanizeLabel(children) : (children ?? statusLabel(status))}
    </span>
  );
};

export default Badge;
